import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ActivityIcon, BrainIcon, ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
export function MechanismSection() {
  const bodyItems = [{
    title: 'Comida real',
    desc: '(0 azúcar, 0 ultraprocesados): energía estable'
  }, {
    title: 'Movimiento diario',
    desc: 'sistema nervioso regulado'
  }, {
    title: 'Luz solar al despertar',
    desc: 'ritmo circadiano ordenado'
  }, {
    title: 'Pantallas off 1 hora antes',
    desc: 'sueño profundo'
  }, {
    title: 'Hidratación con sal',
    desc: 'claridad mental'
  }];
  const soulItems = [{
    title: 'Gratitud mañana y noche',
    desc: 'estado de apertura'
  }, {
    title: 'Afirmaciones escritas',
    desc: '(7 chakras): alineación integral'
  }, {
    title: "Journaling 'Observador'",
    desc: 'vaciás la cabeza, elegís consciente'
  }, {
    title: 'Diagnóstico de autoestima',
    desc: 'te ves con honestidad'
  }];
  return <section id="mechanism" className="py-14 md:py-32 bg-charcoal-dark border-y border-charcoal-light" data-id="element-178">
      <div className="max-w-5xl mx-auto px-6" data-id="element-179">
        <FadeIn className="text-center mb-10 md:mb-16" data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-offwhite mb-6" data-id="element-181">
            El Mecanismo — Por qué RESET funciona
          </h2>
          <p className="text-lg text-offwhite-dim max-w-2xl mx-auto" data-id="element-182">
            Tu realidad diaria no es un accidente. Se construye en cadena:
          </p>
          <div className="mt-8 flex flex-wrap justify-center items-center gap-2 md:gap-4 text-sm md:text-base font-medium text-sand" data-id="element-183">
            <span data-id="element-184">Pensamiento</span>{' '}
            <ArrowRightIcon className="w-4 h-4 text-charcoal-light" data-id="element-185" />
            <span data-id="element-186">Emoción</span>{' '}
            <ArrowRightIcon className="w-4 h-4 text-charcoal-light" data-id="element-187" />
            <span data-id="element-188">Estado</span>{' '}
            <ArrowRightIcon className="w-4 h-4 text-charcoal-light" data-id="element-189" />
            <span data-id="element-190">Decisión</span>{' '}
            <ArrowRightIcon className="w-4 h-4 text-charcoal-light" data-id="element-191" />
            <span data-id="element-192">Acción</span>{' '}
            <ArrowRightIcon className="w-4 h-4 text-charcoal-light" data-id="element-193" />
            <span className="text-amber font-bold" data-id="element-194">Resultado</span>
          </div>
          <p className="mt-8 text-offwhite-dim" data-id="element-195">
            Si repetís los mismos pensamientos, sentís lo mismo. Si sentís lo
            mismo, tomás las mismas decisiones. Si tomás las mismas decisiones,
            tu vida no cambia.
          </p>
          <p className="mt-4 text-xl font-heading font-bold text-offwhite" data-id="element-196">
            RESET interrumpe ese loop desde 2 frentes simultáneos:
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-197">
          {/* CUERPO */}
          <FadeIn direction="up" delay={0.2} className="bg-charcoal border border-charcoal-light p-8 md:p-10 rounded-sm relative overflow-hidden group hover:border-sand/50 transition-colors" data-id="element-198">
            <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-199">
              <ActivityIcon className="w-32 h-32 text-sand" data-id="element-200" />
            </div>
            <div className="relative z-10" data-id="element-201">
              <div className="flex items-center gap-4 mb-6" data-id="element-202">
                <div className="bg-sand/10 p-3 rounded-sm" data-id="element-203">
                  <ActivityIcon className="w-8 h-8 text-sand" data-id="element-204" />
                </div>
                <h3 className="text-2xl font-heading font-bold text-offwhite" data-id="element-205">
                  CUERPO
                </h3>
              </div>
              <p className="text-amber text-sm font-medium uppercase tracking-wider mb-6" data-id="element-206">
                Regulación física
              </p>
              <p className="text-offwhite-dim mb-8" data-id="element-207">
                Cuando le das al cuerpo señales de seguridad, la mente baja el
                volumen.
              </p>

              <ul className="space-y-4" data-id="element-208">
                {bodyItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-209">
                    <CheckCircle2Icon className="w-5 h-5 text-sand shrink-0 mt-0.5" data-id="element-210" />
                    <span className="text-offwhite-dim" data-id="element-211">
                      <strong className="text-offwhite font-medium" data-id="element-212">
                        {item.title}
                      </strong>{' '}
                      {item.desc}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* ALMA */}
          <FadeIn direction="up" delay={0.4} className="bg-charcoal border border-charcoal-light p-8 md:p-10 rounded-sm relative overflow-hidden group hover:border-amber/50 transition-colors" data-id="element-213">
            <div className="absolute top-0 right-0 p-8 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-214">
              <BrainIcon className="w-32 h-32 text-amber" data-id="element-215" />
            </div>
            <div className="relative z-10" data-id="element-216">
              <div className="flex items-center gap-4 mb-6" data-id="element-217">
                <div className="bg-amber/10 p-3 rounded-sm" data-id="element-218">
                  <BrainIcon className="w-8 h-8 text-amber" data-id="element-219" />
                </div>
                <h3 className="text-2xl font-heading font-bold text-offwhite" data-id="element-220">
                  ALMA
                </h3>
              </div>
              <p className="text-amber text-sm font-medium uppercase tracking-wider mb-6" data-id="element-221">
                Regulación interna
              </p>
              <p className="text-offwhite-dim mb-8" data-id="element-222">
                Cuando entrás en contacto con lo que pensás y sentís, podés
                elegir distinto.
              </p>

              <ul className="space-y-4" data-id="element-223">
                {soulItems.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-224">
                    <CheckCircle2Icon className="w-5 h-5 text-amber shrink-0 mt-0.5" data-id="element-225" />
                    <span className="text-offwhite-dim" data-id="element-226">
                      <strong className="text-offwhite font-medium" data-id="element-227">
                        {item.title}
                      </strong>{' '}
                      {item.desc}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.6} className="mt-10 md:mt-16 text-center" data-id="element-228">
          <p className="text-2xl font-heading font-bold text-sand" data-id="element-229">
            7 días. 30–45 minutos por día.
          </p>
          <p className="mt-2 text-xl text-offwhite-dim" data-id="element-230">
            No perfecto.{' '}
            <span className="text-offwhite font-bold" data-id="element-231">Completo.</span>
          </p>
        </FadeIn>
      </div>
    </section>;
}